var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:(_vm.$router.currentRoute.path.includes('/secretariat/') ||
    _vm.$router.currentRoute.path.includes('Chat') ||
    _vm.$router.currentRoute.path.includes('chat') ||
    _vm.$router.currentRoute.path.includes('videoCall')
      ? 'background-color: #ebebeb'
      : '')},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }